module.exports = "<rides-page></rides-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appRoutes/rides.html
// module id = 1387
// module chunks = 0